import api from './api';

export interface CreateKaizenPayload {
  title?: string;
  idea: string;
  area?: string;
}

export interface KaizenIdeaRow {
  id: string;
  title: string | null;
  idea: string;
  area: string | null;
  createdAt: string;
  submittedBy: {
    id: string;
    fullName: string;
    empNo: string;
    branch: string;
    department: string;
  } | null;
}

export const kaizenService = {
  async submit(payload: CreateKaizenPayload): Promise<{ id: string; message: string }> {
    const response = await api.post('/kaizen', payload);
    return response.data;
  },

  /** Admin / Co-Admin only — backend enforces role. */
  async list(): Promise<KaizenIdeaRow[]> {
    const response = await api.get<KaizenIdeaRow[]>('/kaizen');
    return response.data;
  },
};
